import { useEffect, useState } from 'react';
import { useHistory } from 'react-router-dom';
import { useForm } from '../forms/useForm';
import { usePagination } from '../pagination/usePagination';
import { sendRequest } from '../requests/useRequest';
import { useSweetAlert } from '../sweetAlerts/useSweetAlert';
import { validarSesion } from '../tokens/useToken';

export const useMicContainers = () => {

    const [containersMic, setContainersMic] = useState([]);
    const [containerId, setContainerId] = useState(0);
    const [dataContainerSearch, setContainerSearch] = useState([]);


    const [method, setMethod] = useState("");
    const [modal, setModal] = useState(false);
    const [modalTitle, setModalTitle] = useState("");

    const [loading, setLoading] = useState(false);
    const [createSweet] = useSweetAlert();
    
    const [modalAlert, setModalAlert] = useState(false);
    const [showDeleteAlert, setShowDeleteAlert] = useState(false);
    const [searchTypeSample, setSearchTypeSample] = useState("");
    const [loadingExport, setLoadingExport] = useState(false);
    const history = useHistory();

    const [formValues, handleInputChange, reset, handleUpdateValues,] = useForm({
        name_container: "",
    });
    const [validaciones, setValidaciones] = useState({
        name_valid: false,
    })
    const { name_container, } = formValues;

    const numberItems = 10;
    const { totalPageCount, currentPage, nextPage, previousPage, goToPage } = usePagination(containersMic.length, numberItems);

    useEffect(() => {
        let startItems = 0;
        let endItems = numberItems;

        let aux = numberItems * currentPage;

        endItems = aux;

        startItems = endItems - numberItems;
        let listContainers = [];
        containersMic.forEach((data, key) => {

            let posicion = key + 1;
            let visibleTable = false;

            if (posicion > startItems && posicion <= endItems) {
                visibleTable = true;
            }

            listContainers.push({
                ...data,
                visibleTable: visibleTable
            });
        });

        setContainersMic(listContainers);
    }, [totalPageCount, currentPage])

    // const toggle = () => {
    //     setModal(!modal);
    // }


    const openDialog = (title, mode) => {
        setModalTitle(title);
        setMethod(mode);
        setModal(true);
    };

    const closeDialog = () => {
        setModal(false);
    };

    const openDeleteAlert = () => {
        setShowDeleteAlert(true); 
        setModalAlert(true);  
    };

    const closeDeleteAlert = () => {
        setShowDeleteAlert(false); 
        setModalAlert(false);   
    };
    

    useEffect(() => {
        getContainers();
    }, [history.location]);


    const getContainers = async () => {
        let requestOptions = {
            method: 'GET'
        };

        const respuesta = await sendRequest(requestOptions, "Containers/List");

        if (respuesta.code === 200) {
            let listContainers = [];
            let startItems = 0;
            let endItems = numberItems;
            let aux = numberItems * currentPage;

            endItems = aux;

            startItems = endItems - numberItems;

            if (respuesta.data.length >= 1) {
                respuesta.data.forEach((data, index) => {

                    let posicion = index + 1;
                    let visibleTable = false;

                    if (posicion > startItems && posicion <= endItems) {
                        visibleTable = true;
                    }

                    listContainers.push({
                        id_container: data.id_container,
                        name_container: data.name_container,
                        visibleTable: visibleTable
                    });
                });
                setContainersMic(listContainers);
                setContainerSearch(listContainers);
            }
        }
    }


    const handleCreate = () => {
        handleUpdateValues({
            name_container: "",
        });

        setContainerId(0);
        setMethod("create");
        setModalTitle("Crear nuevo contenedor");
        openDialog("Crear nuevo contenedor", "create");
    }

    const saveCreate = async (e) => {
        e.preventDefault();

        setLoading(true);

        if (validarForm()) {
            setLoading(false);
            return;
        }

        let mValues = JSON.stringify(formValues);

        let requestOptions = {
            method: 'POST',
            body: mValues
        };

        const respuesta = await sendRequest(requestOptions, "Containers");
        if (respuesta.code === 200) {
            getContainers();
            createSweet("create", "success", "Éxito!", "Contenedor creado con éxito");
            setLoading(false);
            closeDialog();
        }
    }

    const handleUpdate = (id_container) => {
        let container = containersMic.find(s => s.id_container === id_container);

        handleUpdateValues({
            name_container: container.name_container,
        });

        setValidaciones({
            name_valid: false,
        });

        setContainerId(id_container);
        setMethod("update");
        setModalTitle("Modificación del contenedor");
        openDialog("Modificar contenedor", "update");
    }

    const saveUpdate = async (e) => {
        e.preventDefault();

        setLoading(true);

        if (validarForm()) {
            setLoading(false);
            return;
        }

        let body = {
            id_container: containerId,
            ...{ ...formValues }
        };

        let mValues = JSON.stringify(body);

        let requestOptions = {
            method: 'PUT',
            body: mValues
        };

        const respuesta = await sendRequest(requestOptions, "Containers/Update");

        if (respuesta.code === 200) {
            getContainers();
            createSweet("create", "info", "Exito!", "Contenedor actualizada");
            setLoading(false);
            closeDialog();
        }
        else if (respuesta.code === 401) {
            validarSesion(history, respuesta.code, saveUpdate);
        }
    }

    const handleDelete = (id_container) => {

        let container = containersMic.find(s => s.id_container === id_container);

        handleUpdateValues({
            name_container: container.name_container,
        });

        setContainerId(id_container);
        setMethod("delete");
        setModalTitle("Eliminar contenedor");
        openDeleteAlert();
    }

    const saveDelete = async (e) => {
        e.preventDefault();

        setLoading(true);

        let requestOptions = {
            method: 'DELETE'
        };

        const respuesta = await sendRequest(requestOptions, `Containers/${containerId}`);

        if (respuesta.code === 200) {
            getContainers();
            setLoading(false);
            createSweet("create", "success", "Exito!", "Contenedor eliminado");
            closeDeleteAlert();
        }
        else if (respuesta.code === 401) {
            validarSesion(history, respuesta.code, saveDelete);
        }
    }

    const validarForm = () => {
        let statusValidation = false;
        let newValidations = {};

        if (formValues.name_container === "" || formValues.name_container.length < 3) {
            newValidations = {
                ...newValidations,
                name_valid: true
            };
            statusValidation = true;
        }
        else {
            newValidations = {
                ...newValidations,
                name_valid: false
            }
        }
        setValidaciones(newValidations);

        return statusValidation;
    }

    // const handleSearchContainer = (e) => {

    //     let busqueda = e.target.value;
    //     let newMethod = [];

    //     dataContainerSearch.forEach(element => {

    //         let cadena = element.name_container.toUpperCase();
    //         if (cadena.indexOf(busqueda.toUpperCase()) > -1) {
    //             element.visibleTable = true;
    //             newMethod.push(element);
    //         }
    //     });
    //     setContainersMic(newMethod);
    // }

        const handleExcelContainersMic = async () => {
        setLoadingExport(true);

        try {
            const XLSX = await import("xlsx");

            const _report = containersMic.map((item, index) => ({
                "#": index + 1,
                "Nombre": item.name_container || "---",                
            }));

            const worksheet = XLSX.utils.json_to_sheet(_report);
            const workbook = XLSX.utils.book_new();
            XLSX.utils.book_append_sheet(workbook, worksheet, "Listado_contenedores");

            const excelBuffer = XLSX.write(workbook, { bookType: "xlsx", type: "array" });

            const dataBlob = new Blob([excelBuffer], {
                type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet"
            });

            const url = window.URL.createObjectURL(dataBlob);
            const link = document.createElement("a");
            link.href = url;
            link.download = "catálogo_contenedores.xlsx";
            document.body.appendChild(link);
            link.click();
            document.body.removeChild(link);
            window.URL.revokeObjectURL(url);

        } catch (error) {
            console.error("Error al exportar Excel", error);
        }

        setLoadingExport(false);
    };

    const [searchContainer, setSearchContainer] = useState("");

    const handleSearch = (e) => {
        setSearchContainer(e);

        let busqueda = e.toUpperCase();
        let newContainer = [];

        if (busqueda === "") {
            setContainersMic([...dataContainerSearch]); 
        } else {
            dataContainerSearch.forEach(element => {
                let cadena = element.name_container.toUpperCase();
                if (cadena.indexOf(busqueda) > -1) {
                    newContainer.push(element);
                }
            });
            setContainersMic(newContainer);
        }
    }

    const handleClear = () => {
        setSearchContainer("");                         
        localStorage.removeItem("globalFilter");    
        setContainersMic([...dataContainerSearch]);
    };



    return {
        containersMic, name_container, validaciones,
        method,
        handleInputChange, loading,
        closeDialog, modal, modalTitle,
        handleCreate, saveCreate,
        handleUpdate, saveUpdate,
        handleDelete, saveDelete,
        nextPage, previousPage, goToPage, totalPageCount, currentPage,
        openDeleteAlert, closeDeleteAlert, showDeleteAlert, modalAlert,
        handleExcelContainersMic, loadingExport, handleClear, handleSearch, searchContainer
    }

}




